function lazyLoadDiv() {

	if ('IntersectionObserver' in window) {
		var lazyLoadElements = document.querySelectorAll('[cnd-lazy-load]');

		const observer = new IntersectionObserver((entries, observer) => {
			entries.forEach(entry => {

				if (entry.isIntersecting) {

					var lazyLoadElementIndex = entry.target.getAttribute('cnd-lazy-load');
					var iframeEmbed = decodeHtml(window['cndLazyLoadCode' + lazyLoadElementIndex]);

					var scriptFilePattern = /\(document,\s?'script',\s?'(.*?)'\)/gmi;
					var scriptFileMatches = [];
					var match;
					while ((match = scriptFilePattern.exec(iframeEmbed)) !== null) {
						scriptFileMatches.push(match);
					}

					var scriptFileContent = [];

					scriptFileMatches.forEach(match => {
						scriptFileContent.push(match[1]);
						iframeEmbed = iframeEmbed.replace(match[0], '');
					});

					var scriptPattern = /<\s*script[^>]*>((.|\n|\r)*?)<\s*\/\s*script>/gmi;
					var matches = [];
					var match;
					while ((match = scriptPattern.exec(iframeEmbed)) !== null) {
						matches.push(match);
					}
					var scriptContent = '';

					matches.forEach(match => {
						// append script content to be output later
						scriptContent += match[1];
						// remove the script tag from the iframe embed code
						iframeEmbed = iframeEmbed.replace(match[0], '');
					});

					entry.target.innerHTML = iframeEmbed;
					observer.unobserve(entry.target);

					var newScript = document.createElement('script');
					newScript.textContent = scriptContent;
					document.body.append(newScript);

					scriptFileContent.forEach(scriptFile => {
							var newScript = document.createElement('script');
							newScript.src = scriptFile;
							document.body.append(newScript);
						}
					);
				}
			});
		});

		// Start observing the target element
		lazyLoadElements.forEach(lazyLoadElement => {
			observer.observe(lazyLoadElement);
		});

	} else {
		// Fallback for browsers that do not support Intersection Observer
		// You can load the content immediately or use another method
		console.log('Intersection Observer not supported');
	}
}

function decodeHtml(html) {
	var txt = new DOMParser().parseFromString(html, 'text/html');
	return txt.documentElement.textContent;
}

document.addEventListener('DOMContentLoaded', function () {
	lazyLoadDiv();
});
